const bannerChange = () => {

    
    window.onresize = e => {

        
        if ($(window).width() > 992) {

            var x = document.getElementsByClassName('banner-img');
            var i;

            for (i = 0; i < x.length; i++) {
                x[i].setAttribute("src", x[i].getAttribute("data-image"));
            }

        } else {
            var x = document.getElementsByClassName('banner-img');
            var i;

            for (i = 0; i < x.length; i++) {
                x[i].setAttribute("src", x[i].getAttribute("data-mobileimage"));
            }
        }
    }

   

};

export {
    bannerChange
};
